<div class="main-router">
<div class="container-fluid">
  <div class="row">
          <div class="header">
              <div class="container-fluid">
                <p class="headerText">
                  <strong>List Of CSC Payments </strong>
                </p>
              </div>
            </div>
          </div>
      <div class="mt-3 mb-3 list-group-item">
<form ngNoForm action="{{host}}/csc/pay" method="post" id="vlepay">
      <input type="hidden" id="vlechallanid" name="challanNo" value="">
</form>
<h3 class="text-center">List of Payments </h3>
 <table class="table table-hover table-bordered table-striped">
   <thead>
  <tr>
    <th scope="col" style="width: 2%">#</th>
    <th scope="col" style="width: 12.66%">Worker Name </th>
    <th scope="col"> <span class="colorblue">ChallanId</span>
      <br>
      <span class="colororange">Merchant Transection No</span>
    </th>
    <th scope="col" style="width: 14.66%"><span style="color:green">Amount</span>
      <br>
      <span class="colororange">Receipt No</span>
      <br>
      <span class="colormain">VLE ID</span>
    </th>
    <th scope="col">Transection Date</th>
    <th scope="col">Action</th>
  </tr>
</thead>
<tbody>
  <tr *ngFor="let item of penddingTransections; index as i">
    <th scope="row">{{i+1}}</th>
    <th scope="col">{{item.WRG_Name}}<br> </th>
    <td class="text-uppercase">
      <span class="colorblue">{{item.ChallanId}}</span>
      <br>
      <span class="colororange">{{item.csc_merchant_txn}}</span>
    </td>
    <td>
      <span style="color:green"> {{item.Amount}} Rs/-</span>
      <br>
      <span class="colororange"> {{item.csc_receipt_no}}</span>
      <br>
      <span class="colormain">{{item.csc_vleid}}</span>
    </td>
    <td>{{item.txn_date}}</td>
    <td>
      <button mat-raised-button color="primary" (click)="initRefund(item)">Initiate Refund</button>
      <button mat-raised-button color="primary" (click)="initreversal(item)" *ngIf="item.isSuccess!=1 && isReversal(item)">Initiate Reversal</button>
      <!-- <a class="m-1" title="View" (click)="jumptoView('renew',item.wc_serialcode)"><i class="fa fa-external-link-square" style="font-size:20px; color:#008bf9; font-weight:bold"></i></a> -->
    </td>
  </tr>
</tbody>
</table>
</div>
</div>
</div>
